<ag-grid-row-count [gridApi]="gridApi" [gridTracker]="gridTracker" [gridOptions]="gridOptions"></ag-grid-row-count>
@if (showApprovalButtons) {
    <div class="approval-actions mt-1 mb-1">
        <button type="button" class="ace-btn btn-sm btn-primary me-1"
                [disabled]="!hasApprovalSelection"
                (click)="openApprovalActionModal(approvalStatusApproved, 'Approved')">Mark Approved</button>
        <button type="button" class="ace-btn btn-sm btn-primary me-1"
                [disabled]="!hasApprovalSelection"
                (click)="openApprovalActionModal(approvalStatusRejected, 'Rejected')">Mark Rejected</button>
        <button type="button" class="ace-btn btn-sm btn-secondary me-1"
                [disabled]="!hasApprovalSelection"
                (click)="openApprovalCommentModal()">Add/Update Approver Comment</button>
        <button type="button" class="ace-btn btn-sm btn-secondary"
                [disabled]="!hasApprovalSelection"
                (click)="onResetClick()">Reset</button>
        <label class="ms-3 mb-0 align-self-center">
            <input type="checkbox"
                   [(ngModel)]="filterWhereImApprover"
                   (ngModelChange)="onFilterWhereImApproverChange()" />
            Where I'm Approver
        </label>
    </div>
}
<ws-ag-grid-angular [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)"
                    style="display: block;"
                    [gridId]="gridId"
                    [exportOptions]="exportOptions"
                    [isBulkDeleteVisible$]="isBulkDeleteVisible$"
                    [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                    (bulkDelete)="bulkDelete()"
                    (bulkUpdate)="bulkUpdate()">
</ws-ag-grid-angular>
